import { createContext } from "react";
import { v4 as uuid } from "uuid";
import { UserInfo } from "../api/Organization";

export interface UserContext {
  userInfo: UserInfo | null;
  userPhotoVersion: string;
  refreshPhoto: () => void;
}

export const UserContext = createContext<UserContext>({
  userInfo: null,
  userPhotoVersion: uuid(),
  refreshPhoto: () => {},
});
